module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch10"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Who’s Bending Down to Give Me a Rainbow?")])])]), _vm._v(" "), _c('p', {
    staticClass: "DLF"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1:39 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("I don’t see any reason why I can’t stay in this bathroom for the rest of the day. It’s got everything I need, really. A toilet. A sink. Plenty of light from the window above the last stall. It’s like my own little apartment inside the school. There "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("is")]), _vm._v(" the issue of food, but after what happened back there with the banana bread, I’m fairly certain I’m off food for a while.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I won’t be able to vote. That’s one downside to hiding out in here. Students will be casting their ballots when they get back to their homeroom classes. But I don’t think it really matters. After that debacle, there’s no way Rhiannon and I are winning this thing.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I pull a paper towel from the dispenser and wipe the remnant tears from my eyes and then blow my stuffed-up nose.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’ve now cried twice in one day.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’m on a roll.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I toss the towel in the trash and stare at my reflection in the mirror for a long hard minute. My lips are still absurdly enormous. I contort them this way and that, puckering them like a fish and flapping them like a horse. Anything I can do to try to encourage the blood to flow back out. I guess I should be grateful. I could have been born with a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("deadly")]), _vm._v(" nut allergy. I could be in an ambulance right now on my way to the hospital.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I really do look like a cartoon character. And here I thought guys "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("liked")]), _vm._v(" girls with big lips. Maybe just not "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("this")]), _vm._v(" big.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I purse my lips in the mirror, giving my best sultry bedroom eyes. “Well, hello there,” I say breathily to my reflection. “Come here often? What’s that? You think I’m sexy?” I make a kissing sound and then quickly wipe the drool that dribbles out as a result.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I lean forward, pretending to give the stranger in the mirror a big, slobbery, swollen kiss. But my romantic moment is cut short when I hear footsteps outside the bathroom door.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Is the assembly over already?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Panicked, I glance into one of the stalls, searching desperately for help. The porcelain toilet stares unsupportively back at me, as if to say “So what’s your brilliant plan now, genius?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Since I don’t live in a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Harry Potter")]), _vm._v(" movie, I suppose "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("in")]), _vm._v(" is out of the question. And that means there’s really no place left to go but up. Cringing, I climb onto the questionably clean seat, perching on my tiptoes along the rim and bending myself awkwardly into a crouch.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Classy, Ellie. Really, really classy.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I silence my thoughts with a grit of my teeth. Right now I just have to concentrate on not falling in. This isn’t as easy as they make it look in the movies.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The door opens and someone walks in. I hold my breath. The footsteps pause for a moment, then shuffle hesitantly before pausing again.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("What is this girl doing?")]), _vm._v(" Is she checking each individual stall for the cleanest one? Get on with it already! This is a public high school. There "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("are")]), _vm._v(" no clean stalls!")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I bite my tongue against the slight quiver in my upper legs. How much longer can I realistically keep this up? But it’s not like I can come down now, because then whoever’s in here will know that I’ve been squatting atop a toilet seat.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Ellie? Are you in here?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I blink in surprise at the sound of the distinctly "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("male")]), _vm._v(" voice. “Owen?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I hop down from the toilet seat, my thighs screaming with relief, and open the stall. There’s Owen, all gangly six-foot-one of him, standing in the middle of the girls’ bathroom. I remember the summer that he sprouted. It was when we were counselors in training at Camp Awahili. I didn’t notice the growth spurt because I was with him every day, but when his parents came to pick him up at the end of the summer his mother nearly fainted when she saw him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What are you doing in here?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Looking for you,” he says, as though it’s obvious.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I awkwardly massage my thighs as I hobble out of the stall.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Hiding out in the bathroom?” He raises an eyebrow. “A little cliché, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I run the faucet and scrub my hands. “It’s only cliché because there’s nowhere else to hide in a high school.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Janitor’s closet, theater dressing rooms, that weird little patch of trees behind the track.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I pull a paper towel from the dispenser. “You’ve spent way too much time thinking about this.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So,” he begins, changing the subject. “I looked up the most popular recipe for banana bread on my phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He cringes. “And it has almond "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("extract")]), _vm._v(" in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I slump. “Do you think she did it on purpose?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Put almond extract in her banana bread on the off chance that Ellison Sparks comes to buy something from the cheerleader bake sale right before her election speech? Now you’re sounding like a paranoid politician.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I slap his arm. “No, I mean, do you think she deliberately "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("lied")]), _vm._v(" to me about there being almonds in the bread?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Honestly? No. I think she probably didn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I sigh. He might be right.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Anyway”—he pulls a small pill from his back pocket—“I got this in the nurse’s office. Benadryl. It’ll help with the swelling.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Gratefully I lunge for the capsule, popping it in my mouth and swallowing it dry. “Thank you!” I croak.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I know what you need,” he says, pulling my phone from the back pocket of my jeans. A few seconds and several swipes later, the catchy opening bass solo of “Windy” by The Association funnels out of the speaker.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He’s accessed my “Bubble Yum” playlist, consisting of all the bounciest pop songs of the sixties.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The gesture is sweet, and honestly, watching Owen jump around the girls’ bathroom singing "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Who’s peeking out from under a stairway”")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("is")]), _vm._v(" rather comical, but I’m far too depressed to even crack a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I take the phone back from him, turn off the song mid-chorus, and return it to my pocket. “Thanks, Owen, but I’m not in the mood.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s the whole point of the ‘Bubble Yum’ playlist,” Owen argues. “To "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("change")]), _vm._v(" your mood! You said so yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah. I did. Back when my biggest problem was a B minus on a calculus test and my sister’s Urban Dictionary obsession. My life is over now. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Over")]), _vm._v(". I can never show my face out there ever again.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Now the tears are falling for a third time. Gosh, who opened the floodgates today?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I don’t understand. Yesterday my life was amazing. And just like that, it’s turned into total cow plop.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I grab for another paper towel and dab at my nose.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Let me see,” Owen says.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What?” I turn, and before I can react, Owen’s hands are on my cheeks, holding me still. His face lingers close to mine. Closer than I think we’ve ever been before. I glance down. His eyes are determinedly focused on my swollen lips, his brows knitted in concern. I’m actually surprised by how warm his hands are. Did he stick them in his armpits before he came in here, or are they always that warm? I’ve known him for seven years. How come I’ve never noticed the temperature of his hands before?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I think the swelling’s going down,” he assesses, sounding remarkably like a doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His eyes drift up and, for a brief moment, land on mine. I can see the tiny flecks of brown in the green. I never noticed "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("that")]), _vm._v(" before either.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s weird, yet oddly not weird, to be this close to Owen.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And then it feels weird that it’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("not")]), _vm._v(" weird.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Owen suddenly seems to become aware of our proximity and steps back, his warm fingers sliding from my face.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Thanks,” I mumble lamely, and look away.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He takes an exaggerated deep breath and glances around the bathroom. “So "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("this")]), _vm._v(" is what it looks like in here?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Does it live up to your fantasies?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He scowls. “Only pervs fantasize about the girls’ bathroom.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So you’re calling yourself a perv?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He flashes me a mischievous grin.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And just like that, we’re back to being us.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I don’t get it,” I complain. “What is it about the girls’ bathroom that’s so enticing? It’s not like we come in here, strip off all our clothes, and dance naked together.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Shhh,” Owen whispers desperately. “You’re ruining it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“People "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("pee")]), _vm._v(" in here. Among "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("other")]), _vm._v(" things.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“La la la!” Owen sings, covering his ears. “I’m not listening!” He waits to make sure I’ve finished talking and then slowly lowers his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sometimes I come in here and it smells "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("so")]), _vm._v(" bad it’s like a rhinoceros took a huuuuge—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“LA LA LA LA!”")]), _vm._v(" His hands fly to his ears again.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I laugh. Owen watches me, his face breaking into a beatific grin as his hands lower once more.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What?” I ask, tilting my head.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’re laughing.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I scoff. “Yeah, because you’re acting like an idiot.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Mission accomplished.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a6c239","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter10.vue
// module id = 102
// module chunks = 0